import type { GuideWalkthroughDef } from "../types";
import { TRANSPORT_LIST_ROUTE } from "./steps/shared";

/**
 * The order's source, in one concept: open its source document (the blue
 * email/source button next to "Nouvelle commande") — conceptually the order's
 * own source, not the generic Messages panel. Runs INSIDE an order, so
 * `requires` gates on `recap-focus-messages` (focus-view-only — the source
 * button's testid also appears on list rows, so it can't be the gate) to keep
 * it from starting on the list and bouncing the user out.
 */
export const openOrderEmail: GuideWalkthroughDef = {
  id: "open-order-email",
  titleKey: "guide.walkthroughs.openOrderEmail.title",
  requires: "recap-focus-messages",
  requiresBodyKey: "guide.requiresOpenOrder",
  steps: [
    {
      route: TRANSPORT_LIST_ROUTE,
      target: "preorder-source-button",
      bodyKey: "guide.walkthroughs.openOrderEmail.sourceBody",
      advanceOn: "click-target",
    },
  ],
};
